export const DEFAULT_CANVAS_SIZE_PIXELS = 2048;

export const DEFAULT_LEGEND_UNIT_ID = 'gal1ac-1';

export const DEFAULT_BOUNDARY_STROKE_WIDTH_PIXELS = 4;

export const BOUNDARY_STROKE_HEX_COLOR = '#333333';

export const CANVAS_BACKGROUND_HEX_COLOR = '#FFFFFF';

export const SPRAY_PATH_HEX_COLOR = '#32C832';

export const RATE_LOW_HEX_COLOR = '#32C832';

export const RATE_MEDIUM_HEX_COLOR = '#DCDC00';

export const RATE_HIGH_HEX_COLOR = '#E63232';

export const MIN_SPRAY_STROKE_PIXELS = 2;

export const MAX_SPRAY_STROKE_PIXELS = 40;

export const METERS_PER_DEGREE_LATITUDE = 111320;

export const DEFAULT_LEGEND_RANGES = [
    { hexColor: '#32C832', label: 'Low (0-2 gal/ac)', maximum: 33, minimum: 0, percent: 0.35 },
    { hexColor: '#DCDC00', label: 'Medium (2-4 gal/ac)', maximum: 66, minimum: 33, percent: 0.4 },
    { hexColor: '#E63232', label: 'High (4-6 gal/ac)', maximum: 100, minimum: 66, percent: 0.25 }
];
